/**
 * Select — liste déroulante stylisée alignée sur Input.
 */
import { useState } from "react";
import { colors, fonts } from "../styles/tokens";

export default function Select({
  label,
  value,
  onChange,
  options = [],
  required = false,
  error,
  fullWidth = true,
  placeholder = "—",
  ...rest
}) {
  const [focused, setFocused] = useState(false);

  return (
    <label style={{
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      width: fullWidth ? "100%" : "auto",
      fontFamily: fonts.body,
    }}>
      {label && (
        <span style={{ fontSize: "13px", fontWeight: 500, color: colors.textMuted }}>
          {label} {required && <span style={{ color: colors.gold }}>*</span>}
        </span>
      )}
      <select
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value)}
        required={required}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          background: colors.bg,
          color: colors.text,
          border: `1px solid ${error ? colors.rose : focused ? colors.gold : colors.border}`,
          borderRadius: "10px",
          padding: "12px 14px",
          fontSize: "14px",
          outline: "none",
          cursor: "pointer",
          fontFamily: fonts.body,
          boxShadow: focused ? "0 0 0 3px rgba(228,167,44,0.15)" : "none",
          transition: "all 150ms",
          appearance: "none",
          backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><path d='M2 4l4 4 4-4' stroke='%238A97B0' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 12px center",
          paddingRight: "36px",
        }}
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {error && (
        <span style={{ fontSize: "12px", color: colors.rose }}>{error}</span>
      )}
    </label>
  );
}
